import { useState } from "react";
import Button from "@/components/ui/Button";
import Modal from "@/components/ui/Modal";
import Select from "@/components/ui/Select";
import Textarea from "@/components/ui/Textarea";
import { CANCEL_REASONS } from "../data";

interface CancelModalProps {
  open: boolean;
  onClose: () => void;
  refNo: string;
  onConfirm: (reason: string, remarks: string) => void;
  loading?: boolean;
}

export default function CancelModal({ open, onClose, refNo, onConfirm, loading }: CancelModalProps) {
  const [reason, setReason] = useState("");
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState("");

  function handleClose() {
    if (loading) return;
    setReason("");
    setRemarks("");
    setError("");
    onClose();
  }

  function handleConfirm() {
    if (!reason) {
      setError("Please select a reason for cancellation");
      return;
    }
    onConfirm(reason, remarks.trim());
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title="Cancel this mandate?"
      footer={
        <div className="flex items-center justify-end gap-2.5 border-t border-line px-5 py-4">
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Keep Mandate
          </Button>
          <Button variant="danger" onClick={handleConfirm} loading={loading}>
            Cancel Mandate
          </Button>
        </div>
      }
    >
      <p className="text-sm text-ink-secondary">
        This will stop all future debits under reference{" "}
        <span className="font-medium text-ink">{refNo}</span>. This action cannot be undone.
      </p>
      <div className="mt-4">
        <Select
          label="Reason for cancellation"
          required
          options={CANCEL_REASONS}
          placeholder="Select reason"
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            if (e.target.value) setError("");
          }}
          error={error}
        />
      </div>
      <div className="mt-4">
        <Textarea
          label="Remarks"
          placeholder="Optional notes (max 200 characters)"
          maxLength={200}
          rows={3}
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
        />
      </div>
    </Modal>
  );
}